import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ToastContainer, toast } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import "react-toastify/dist/ReactToastify.css";
import MultipleSelectCheckmarks from "components/MultiSelect/MultipleSelectCheckmarks";
import colors from "assets/theme/base/colors";

const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

function Users() {
  // State Declarations
  const [users, setUsers] = useState([]); // Initialize with an empty array
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [departments, setDepartments] = useState([]); // Initialize with an empty array
  const [assignedDepartments, setAssignedDepartments] = useState([]);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [showUpdateUserModal, setShowUpdateUserModal] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [currentUserId, setCurrentUserId] = useState(null);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
// State for Delete Confirmation Modal
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteUserId, setDeleteUserId] = useState(null);

// Open Delete Confirmation Modal
const handleDeleteConfirmation = (userId) => {
  setDeleteUserId(userId);
  setShowDeleteModal(true);
};

// Close Delete Modal
const handleCloseDeleteModal = () => {
  setDeleteUserId(null);
  setShowDeleteModal(false);
};

// Confirm and Delete User
const confirmDeleteUser = async () => {
  await deleteUser(deleteUserId); // Call your delete function
  handleCloseDeleteModal(); // Close modal after deleting
};
  // Fetch Users
  const getUsers = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const response = await fetch(
        `${BASE_URL}/auth/get_admin_users`,
        requestOptions
      );
      const data = await response.json();
      if (response.ok) {
        setUsers(data.users || []); // Ensure data.users is an array
      } else {
        toast.error("Failed to fetch users.");
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Error fetching users.");
    }
  };

  // Fetch Departments
  const getDepartments = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const response = await fetch(
        `${BASE_URL}/department/get_departments`,
        requestOptions
      );
      const data = await response.json();
      if (response.ok) {
        setDepartments(data.departments || []); // Ensure data.departments is an array
      } else {
        toast.error("Failed to fetch departments.");
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
      toast.error("Error fetching departments.");
    }
  };

  // Handle Add User Modal
  const handleAddUser = () => {
    setShowAddUserModal(true);
  };

  const handleCloseAddUserModal = () => {
    setShowAddUserModal(false);
    resetForm();
  };

  // Reset Form
  const resetForm = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPassword("");
    setRole("");
    setAssignedDepartments([]);
  };

  // Add User API
  const addUser = async () => {
    const data = {
      first_name: firstName,
      email,
      password,
      role,
      department_ids: assignedDepartments,
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(
        `${BASE_URL}/auth/add_admin_user`,
        requestOptions
      );
      const result = await response.json();
      if (response.ok) {
        getUsers();
        toast.success("User added successfully");
        handleCloseAddUserModal();
      } else {
        toast.error(result.message || "Failed to add user.");
      }
    } catch (error) {
      console.error("Error adding user:", error);
      toast.error("Error adding user.");
    }
  };

  // Handle Update User
  const handleUpdateUser = (userId) => {
    setCurrentUserId(userId);
    let filter = users.filter((user) => user.id === userId);
    console.log(filter);
    setFirstName(filter[0].name);
    setEmail(filter[0].email);
    setRole(filter[0].role_id);
    setAssignedDepartments(filter[0].department_ids);
    setShowUpdateUserModal(true);
  };

  const handleCloseUpdateUserModal = () => {
    setShowUpdateUserModal(false);
    resetForm();
  };

  // Update User API
  const updateUser = async () => {
    const data = {
      id: currentUserId,
      first_name: firstName,
      last_name: lastName,
      email,
      role,
      department_ids: assignedDepartments,
    };

    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(
        `${BASE_URL}/auth/update_admin_user`,
        requestOptions
      );
      const result = await response.json();
      if (response.ok) {
        getUsers();
        toast.success("User updated successfully");
        handleCloseUpdateUserModal();
      } else {
        toast.error(result.message || "Failed to update user.");
      }
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error("Error updating user.");
    }
  };

  // Delete User
  const deleteUser = async (userId) => {
    const requestOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await fetch(
        `${BASE_URL}/auth/delete_admin_user/${userId}`,
        requestOptions
      );
      const result = await response.json();
      if (response.ok) {
        getUsers();
        toast.success("User deleted successfully");
      } else {
        toast.error(result.message || "Failed to delete user.");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      toast.error("Error deleting user.");
    }
  };

  // Handle Department Assignment
  const handleAssignDepartment = (deptId) => {
    setAssignedDepartments([...assignedDepartments, deptId]);
  };

  const handleRemoveDepartment = (deptId) => {
    setAssignedDepartments(assignedDepartments.filter((id) => id !== deptId));
  };

  // Columns for DataTable
  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "left" },
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Email", accessor: "email", align: "center" },
    { Header: "Role", accessor: "role", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  // Rows for DataTable
  const rows = users.map((user, index) => ({
    serial: index + 1,
    name: user.name,
    role: user.role,
    email: user.email,
    actions: (
      <>
        <IconButton onClick={() => handleUpdateUser(user.id)}>
          <EditIcon style={{ color: "green" }} />
        </IconButton>
        <IconButton onClick={() => handleDeleteConfirmation(user.id)}>
          <DeleteIcon style={{ color: "red" }} />
        </IconButton>
      </>
    ),    
  }));

  // Initial Data Fetching
  useEffect(() => {
    getUsers();
    getDepartments();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3} pt={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card
              sx={{
                marginLeft: "15px",
                boxShadow: "none",
                border: "1px solid #DADADAEE",
                borderRadius: "5px",
              }}
            >
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Button
                  style={{
                    color: "white",
                    background: info.main,
                    fontWeight: 500,
                    height: "40px",
                    fontSize: "16px",
                  }}
                  variant="filled"
                  endIcon={
                    <AddIcon
                      sx={{
                        width: "22px",
                        height: "22px",
                        marginLeft: "22px",
                      }}
                    />
                  }
                  onClick={handleAddUser}
                >
                  Add User
                </Button>
              </MDBox>

              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Add User Modal */}
      <Dialog
        fullScreen={fullScreen}
        open={showAddUserModal}
        onClose={handleCloseAddUserModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="responsive-dialog-title">{"Add User"}</DialogTitle>
        <DialogContent>
          {/* Form Fields */}
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Role</label>
                  <select
                    className="form-select"
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                  >
                    <option value="">Select Role</option>
                    <option value="5">
                      Admission Admin
                    </option>
                    <option value="6">
                      Department
                    </option>
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Assign Departments</label>
                  <MultipleSelectCheckmarks
                    value={assignedDepartments}
                    onChange={(e) => setAssignedDepartments(e.target.value)}
                    options={departments}
                    label="Departments"
                  />
                </div>
              </div>
            </div>
          </div>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseAddUserModal} className="dialog-actions-button negative">
            Cancel
          </Button>
          <Button onClick={addUser} className="dialog-actions-button positive">
            Add
          </Button>
        </DialogActions>
      </Dialog>

      {/* Update User Modal */}
      <Dialog
        fullScreen={fullScreen}
        open={showUpdateUserModal}
        onClose={handleCloseUpdateUserModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="responsive-dialog-title">{"Update User"}</DialogTitle>
        <DialogContent>
          {/* Form Fields */}
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Role</label>
                  <select
                    className="form-select"
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                  >
                    <option value="">Select Role</option>
                    <option value="5">
                      Admission Admin
                    </option>
                    <option value="6">
                      Department
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Assign Departments</label>
                  <MultipleSelectCheckmarks
                    value={assignedDepartments}
                    onChange={(e) => setAssignedDepartments(e.target.value)}
                    options={departments}
                    label="Departments"
                  />
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseUpdateUserModal} className="dialog-actions-button negative">
            Cancel
          </Button>
          <Button onClick={updateUser} className="dialog-actions-button positive">
            Update
          </Button>
        </DialogActions>
      </Dialog>
      {/* Delete Confirmation Modal */}
<Dialog
  open={showDeleteModal}
  onClose={handleCloseDeleteModal}
  aria-labelledby="delete-dialog-title"
  maxWidth="sm"
  fullWidth
>
  <DialogTitle id="delete-dialog-title">Confirm Deletion</DialogTitle>
  <DialogContent>
    <MDTypography variant="body1">
      Are you sure you want to delete this user? This action cannot be undone.
    </MDTypography>
  </DialogContent>
  <DialogActions>
    <Button
      onClick={handleCloseDeleteModal}
      className = "dialog-actions-button negative"
    >
      Cancel
    </Button>
    <Button
      onClick={confirmDeleteUser}
      className = "dialog-actions-button positive"
    >
      Delete
    </Button>
  </DialogActions>
</Dialog>

    </DashboardLayout>
  );
}

export default Users;
